import StockConfiguration from '../shared/configuration/stock-configuration';
class AppConfiguration extends StockConfiguration {
    constructor(_ROOT = document.querySelector('.js-elastic-voorraad')) {
        super(_ROOT);
        this.ROOT = _ROOT;
    }
}
export const appConfiguration = new AppConfiguration();
